/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface TimeTravelResponse {
  user_id: string;
  advance_days: number;
  simulated_now_utc: string;
}
